import {
  addInspectorStart,
  addInspectorSuccess,
  addInspectorFailure,
  fetchInspectorStart,
  fetchInspectorSuccess,
  fetchInspectorFailure,
  fetchInspectorDetailsStart,
  fetchInspectorDetailsSuccess,
  fetchInspectorDetailsFailure,
  blockInspectorStart,
  blockInspectorFailure,
  blockInspectorSuccess,
  editInspectorStart,
  editInspectorFailure,
  editInspectorSuccess,
  uploadFilesStart,
  uploadFilesSuccess,
  uploadFilesFailure,
  fetchInspectorProjectStart,
  fetchInspectorProjectSuccess,
  fetchInspectorProjectFailure,
} from "../../reducer/InspectorManagement/AddInspectorReducer";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  ADD_INSPECTOR,
  GET_INSPECTOR_DATA,
  GET_INSPECTOR_PROJECT_LIST,
  UPLOAD_DOCS,
} from "../../../components/common/api";

let isFetchingInspectors = false;
let isFetchingInspectorDetails = false;
let isUploadingFiles = false;
let isEditUploadingFiles = false;
let isFetchingProjects = false;

// ....................  Add new Inspector  ..................

export const addInspector = (inspectorData) => async (dispatch) => {
  dispatch(addInspectorStart());
  try {
    const response = await axiosInstance.post(
      `${ADD_INSPECTOR}`, inspectorData );

    dispatch(addInspectorSuccess(response.data));
    return response.data;
  } catch (error) {
    console.error("Error in addInspector action:", error);
    dispatch(
      addInspectorFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
    throw error;
  }
};

//  .............  Get Inspector list  data  .....................

export const fetchInspectors =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder) =>
  async (dispatch) => {
    if (isFetchingInspectors) return;
    isFetchingInspectors = true;
    dispatch(fetchInspectorStart());

    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        // sort: sortField || "createdAt",
        sort: sortField || "updatedAt",
        order: sortOrder || "DESC",
      };
      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      const response = await axiosInstance.get(`${GET_INSPECTOR_DATA}`, {
        params,
      });
      dispatch(
        fetchInspectorSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchInspectorFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isFetchingInspectors = false;
    }
  };

// .............. Get inspector view details  ...................

export const GetInspectorsDetails = (inspectorId) => async (dispatch) => {
  if (isFetchingInspectorDetails) return;
  isFetchingInspectorDetails = true;
  dispatch(fetchInspectorDetailsStart());
  try {
    const response = await axiosInstance.get(`${ADD_INSPECTOR}`, {
      params: { user_id: inspectorId },
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }

    dispatch(fetchInspectorDetailsSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchInspectorDetailsFailure(error.message));
  } finally {
    isFetchingInspectorDetails = false;
  }
};

// .................. Block the inspector ...................

export const BlockInspectors = (inspectorId, status) => async (dispatch) => {
  dispatch(blockInspectorStart());
  try {
    const response = await axiosInstance.patch(
      `${ADD_INSPECTOR}?user_id=${inspectorId}&active=${status}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to block inspector.");
    }

    dispatch(blockInspectorSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error blocking inspector:", error);
    dispatch(blockInspectorFailure(error.message));
  }
};

// .............. Edit inspector data..............

export const EditInspectors = (formData) => async (dispatch) => {
  dispatch(editInspectorStart());
  try {
    const response = await axiosInstance.put(`${ADD_INSPECTOR}`, formData);
    if (response.status !== 200) {
      throw new Error("Failed to update inspector.");
    }
    dispatch(editInspectorSuccess(response?.data?.result));
    return { success: true, data: response.data.result };
  } catch (error) {
    console.error("Error updating inspector:", error);
    dispatch(editInspectorFailure(error));
    return { success: false, error: error.message };
  }
};

// ................. Edit Change Password .............

export const EditInspectorsPassword =
  (user_id, password) => async (dispatch) => {
    dispatch(editInspectorStart());
    const formData = { user_id, password };
    try {
      const response = await axiosInstance.put(`${ADD_INSPECTOR}`, formData);
      if (response.status !== 200) {
        throw new Error("Failed to update inspector.");
      }
      dispatch(editInspectorSuccess(response?.data?.result));
      return { success: true, data: response.data.result };
    } catch (error) {
      console.error("Error updating inspector:", error);
      dispatch(editInspectorFailure(error.message));
      return { success: false, error: error.message };
    }
  };

// .................  Upload docs ........................

export const uploadFiles = (files) => async (dispatch) => {
  if (isUploadingFiles) return;
  isUploadingFiles = true;
  dispatch(uploadFilesStart());
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file);
    });

    const response = await axiosInstance.post(`${UPLOAD_DOCS}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200) {
      dispatch(uploadFilesSuccess(response?.data));
      return {
        success: true,
        data: response?.data?.result || response?.data,
      };
    } else {
      throw new Error("File upload failed");
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch(uploadFilesFailure(errorMessage));
    return { success: false, error: errorMessage };
  } finally {
    isUploadingFiles = false;
  }
};

// ................. Edit inspector upload filess .....................

export const uploadEditFiles = (files) => async (dispatch) => {
  if (isEditUploadingFiles) return;
  isEditUploadingFiles = true;
  dispatch(uploadFilesStart());

  try {
    const formData = new FormData();
    files.forEach((file) => {
      if (file instanceof File) {
        formData.append("file", file, file.name);
      } else if (file.filePath) {
        formData.append("file", new Blob(), file.filePath);
      }
    });
    const response = await axiosInstance.post(`${UPLOAD_DOCS}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200) {
      dispatch(uploadFilesSuccess(response.data));
      return {
        success: true,
        data: response.data?.result || response.data,
      };
    } else {
      throw new Error("File upload failed");
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch(uploadFilesFailure(errorMessage));
    return { success: false, error: errorMessage };
  } finally {
    isEditUploadingFiles = false;
  }
};

//  .............  Get Inspector list  data  .....................

export const fetchInspectorsProjectList =
  (currentPage, itemsPerPage, searchTerm, tabName, inspectorId) =>
  async (dispatch) => {
    if (isFetchingProjects) return;
    isFetchingProjects = true;
    dispatch(fetchInspectorProjectStart());
    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: "createdAt",
        order: "DESC",
        inspector_id: inspectorId,
      };
      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      if (tabName === "Ongoing Projects") {
        params.status = "2";
      } else if (tabName === "Past Projects") {
        params.status = "1";
      } else if (tabName === "Assigned Projects") {
        params.status = "0";
      }
      const response = await axiosInstance.get(
        `${GET_INSPECTOR_PROJECT_LIST}`,
        { params }
      );
      dispatch(
        fetchInspectorProjectSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchInspectorProjectFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isFetchingProjects = false;
    }
  };
